import {
  CURRENT_PIN_CODE_REQUIRED_MESSAGE,
  EMAIL_REGEX,
  NEW_PIN_CODE_REQUIRED_MESSAGE,
  PHONE_NUMBER_IS_INVALID,
  PIN_CODE_CONFIRMATION_REQUIRED_MESSAGE,
  PIN_CODE_REQUIRED_FOUR_DIGITS_MESSAGE,
  PIN_CODE_REQUIRED_MESSAGE,
  PIN_CODE_REQUIRED_SIX_DIGITS_MESSAGE,
  PIN_LENGTH,
  PIN_MISMATCH_MESSAGE,
  TRANSACTIONS_PIN_LENGTH,
} from "@zenith/data/constants";

export const setEmailValidations = (email: string, error?: string) => {
  let hasError = false;
  let message = "";
  if (email.length < 1) {
    hasError = true;
    message = "Email is required";
  } else if (!EMAIL_REGEX.test(email)) {
    hasError = true;
    message = "Email address is not valid";
  } else if (error === "ZENZ-CROSS-008") {
    hasError = true;
    message = "This email is not registered on ZenZ";
  }

  return {
    hasError,
    message,
  };
};

export const setOtpValidations = (pin: string) => {
  let hasError = false;
  let message = "";

  if (!pin.length) {
    hasError = true;
    message = "OTP code is required";
  } else if (pin.length > 0 && pin.length < 6) {
    hasError = true;
    message = "OTP code must contain six (6) digits";
  }

  return {
    hasError,
    message,
  };
};

export const setPinValidations = (pin: string) => {
  let hasError = false;
  let message = "";

  if (!pin.length) {
    hasError = true;
    message = PIN_CODE_REQUIRED_MESSAGE;
  } else if (pin.length > 0 && pin.length < PIN_LENGTH) {
    hasError = true;
    message = PIN_CODE_REQUIRED_SIX_DIGITS_MESSAGE;
  }

  return {
    hasError,
    message,
  };
};

export const setConfirmPinValidations = (pin: string) => {
  let hasError = false;
  let message = "";

  if (!pin.length) {
    hasError = true;
    message = PIN_CODE_CONFIRMATION_REQUIRED_MESSAGE;
  } else if (pin.length > 0 && pin.length < PIN_LENGTH) {
    hasError = true;
    message = PIN_CODE_REQUIRED_SIX_DIGITS_MESSAGE;
  }

  return {
    hasError,
    message,
  };
};

export const setCurrentTransactionPinValidations = (currentPin: string) => {
  let hasError = false;
  let message = "";

  if (!currentPin.length) {
    hasError = true;
    message = CURRENT_PIN_CODE_REQUIRED_MESSAGE;
  } else if (
    currentPin.length > 0 &&
    currentPin.length < TRANSACTIONS_PIN_LENGTH
  ) {
    hasError = true;
    message = PIN_CODE_REQUIRED_FOUR_DIGITS_MESSAGE;
  }

  return {
    hasError,
    message,
  };
};

export const setTransactionPinValidations = (
  pin: string,
  confirmPin?: string,
  isPinChange?: boolean
) => {
  let hasError = false;
  let message = "";

  if (!pin.length) {
    hasError = true;
    message = isPinChange
      ? NEW_PIN_CODE_REQUIRED_MESSAGE
      : PIN_CODE_REQUIRED_MESSAGE;
  } else if (pin.length > 0 && pin.length < TRANSACTIONS_PIN_LENGTH) {
    hasError = true;
    message = PIN_CODE_REQUIRED_FOUR_DIGITS_MESSAGE;
  } else if (
    pin.length === TRANSACTIONS_PIN_LENGTH &&
    confirmPin?.length === TRANSACTIONS_PIN_LENGTH &&
    pin !== confirmPin
  ) {
    message = PIN_MISMATCH_MESSAGE;
    hasError = true;
  }

  return {
    hasError,
    message,
  };
};

export const setConfirmTransactionPinValidations = (pin: string) => {
  let hasError = false;
  let message = "";

  if (!pin.length) {
    hasError = true;
    message = PIN_CODE_CONFIRMATION_REQUIRED_MESSAGE;
  } else if (pin.length > 0 && pin.length < TRANSACTIONS_PIN_LENGTH) {
    hasError = true;
    message = PIN_CODE_REQUIRED_FOUR_DIGITS_MESSAGE;
  }

  return {
    hasError,
    message,
  };
};

export const setPhoneNumberValidations = (
  phoneNumber: string,
  maxLength: number
) => {
  let hasError = false;
  let message = "";
  if (!phoneNumber.length) {
    hasError = true;
    message = "Phone number is required";
  } else if (phoneNumber.length < maxLength) {
    hasError = true;
    message = PHONE_NUMBER_IS_INVALID;
  }

  return {
    hasError,
    message,
  };
};

export const setAccountNumberValidations = (
  accountNumber: string,
  maxLength?: number
) => {
  let hasError = false;
  let message = "";
  if (!accountNumber) {
    hasError = true;
    message = "Zenith account number is required";
  } else if (maxLength && accountNumber.length < maxLength) {
    hasError = true;
    message = "Zenith account number is required";
  }

  return {
    hasError,
    message,
  };
};

export const setConfirmPinSignUpValidations = (
  pin: string,
  confirmPin?: string | undefined
) => {
  let hasError = false;
  let message = "";

  if (
    pin.length === PIN_LENGTH &&
    confirmPin?.length === PIN_LENGTH &&
    pin !== confirmPin
  ) {
    hasError = true;
    message = PIN_MISMATCH_MESSAGE;
  } else if (!pin.length) {
    hasError = true;
    message = PIN_CODE_CONFIRMATION_REQUIRED_MESSAGE;
  }
  return {
    hasError,
    message,
  };
};
